import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

import { createIntervalFailed, createIntervalSuccessful } from '../actions';
import { CREATED } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';

export default function* createInterval(action) {
  try {
    const {
      id,
      data,
    } = action.payload;
    const url = `${BACKEND_URL}/proxy/subscription/v1/subscriptions/${id}/intervals`;
    const dataResponse = yield makeRequest(url, data, action, 'POST', true);
    if (dataResponse.status === CREATED) {
      const responseData = yield dataResponse.json();
      const createdInterval = responseData?.data || responseData || {};
      yield put(createIntervalSuccessful(createdInterval));
      yield call(resolveActionPromise(action, createdInterval));
    } else {
      const data = yield dataResponse.json();
      yield put(createIntervalFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createIntervalFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
